import { pushMessage } from 'actionCreators/messages';
import { get, put } from 'services/api';
import { Profile } from 'interface/profile';
import { IUser } from 'interface/user';
import { hjTagging } from 'utils';
import { withLoader } from 'utils/reduxLoader';
import * as rxjs from 'rxjs';
import { getStore } from '../redux/store';
import { API_V4_BASE_URL } from 'settings';

declare let gtag: (command: string, value: any) => void;

export class profile {
  private profilePicture$ = new rxjs.BehaviorSubject<string>('');

  public getProfileInfo(): Promise<Profile> {
    const request = get({
      url: `/user`,
      baseURL: API_V4_BASE_URL,
    }).then((response) => {
      const userId = response.data.data.user;
      hjTagging(`USER-${userId}`);
      this.profilePicture$.next(response.data.data.avatar);
      // SET USER ID TO TRACKING IN GOOGLE ANALYTICS ...
      gtag('set', { user_id: userId });
      return response.data.data;
    });

    return withLoader(request);
  }

  public getProfilePicture(): rxjs.Observable<string> {
    return this.profilePicture$;
  }

  public updateProfileInfo(user: Partial<IUser>): Promise<any> {
    const request = put({
      url: `/user`,
      baseURL: API_V4_BASE_URL,
      data: user,
    })
      .then((response) => {
        getStore().dispatch(pushMessage('Perfil atualizado com sucesso', 'success'));
        this.updateProfilePicture(user.avatar);
        return response.data.data;
      })
      .catch((err) => {
        const message = err.response.data.message;
        getStore().dispatch(pushMessage(message, 'error'));
      });

    return withLoader(request);
  }

  private updateProfilePicture(newPicture: string): void {
    this.profilePicture$.next(newPicture);
  }
}

const profileService = new profile();

export default profileService;
